import { render, staticRenderFns } from "./DiscountRulesSettingNew.vue?vue&type=template&id=1772862d&"
import script from "./DiscountRulesSettingNew.vue?vue&type=script&lang=js&"
export * from "./DiscountRulesSettingNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports